var _defs, _rect, _rect2, _rect3, _g, _g2, _text, _text2, _text3, _text4, _text5, _text6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotanicalSage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 520",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgSage",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f5f3ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ecefe5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "noise2"
  }, /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: 0.85,
    numOctaves: 2,
    stitchTiles: "stitch"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.045 0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "leafCluster"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 90 Q 50 50 90 10",
    fill: "none",
    stroke: "#7a8b5e",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 78 Q 26 60 40 56",
    fill: "#a3b681",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 60 Q 42 44 56 40",
    fill: "#a3b681",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 44 Q 58 28 72 24",
    fill: "#a3b681",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 84 Q 20 70 36 64",
    fill: "#c9d4a8",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 56 Q 48 40 64 34",
    fill: "#c9d4a8",
    opacity: 0.5
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 520,
    fill: "url(#bgSage)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 399,
    height: 519,
    fill: "none",
    stroke: "#c7d3bd",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 520,
    filter: "url(#noise2)",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 8) scale(1.1)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#leafCluster"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(392 512) scale(-1.1, -1.1)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#leafCluster"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 200,
    textAnchor: "middle",
    fontFamily: "Allura, cursive",
    fontSize: 58,
    fill: "#3d4a32"
  }, "Juliet")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 250,
    textAnchor: "middle",
    fontFamily: "Italianno, cursive",
    fontSize: 42,
    fill: "#7a8b5e"
  }, "&amp;")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 310,
    textAnchor: "middle",
    fontFamily: "Allura, cursive",
    fontSize: 58,
    fill: "#3d4a32"
  }, "Romeo")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 360,
    textAnchor: "middle",
    fontFamily: "Cormorant SC, serif",
    fontSize: 11,
    letterSpacing: 3,
    fill: "#3d4a32"
  }, "SATURDAY \xB7 SEPTEMBER TWELFTH")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 382,
    textAnchor: "middle",
    fontFamily: "Cormorant SC, serif",
    fontSize: 10,
    letterSpacing: 3,
    fill: "#4f5b40"
  }, "TWO THOUSAND TWENTY SIX")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 425,
    textAnchor: "middle",
    fontFamily: "Italianno, cursive",
    fontSize: 26,
    fill: "#7a8b5e"
  }, "Join us in our happiness")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotanicalSage);
export default __webpack_public_path__ + "static/media/botanicalSage.aca3497d0710cac0b98ca8adf7ee24bb.svg";
export { ForwardRef as ReactComponent };